<!-- User Management /internalApp/userCreation -->
<ul class="breadcrumb" *ngIf="(roleName==='System Admin' || roleName==='ServerSecExecutive') &&  (router.url.includes('usrmgt/') || router.url.includes('auditLog/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('usrmgt/internalApp'))">
        <a routerLink="usrmgt/internalApp" routerLinkActive="active">User Management Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('usrmgt/internalApp/userCreation;key'))">
        <a>Edit User</a>
    </li>
    <li *ngIf="(router.url===('/main/internal/usrmgt/internalApp/userCreation'))">
        <a>User Creation</a>
    </li>
    <li *ngIf="(router.url.includes('auditLog/dashboard'))">
        <a routerLinkActive="active">Audit Log Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('auditLog/moduleDashboard'))">
        <a routerLinkActive="active">Module Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('auditLog/view'))">
        <a routerLinkActive="active">Audit Log View</a>
    </li>
</ul>

<!-- UG -->
<ul class="breadcrumb" *ngIf="roleName==='NewCollege'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>   
    <li *ngIf="(router.url.includes('main/internal/ug/NewCollege'))">
        <a>Apply for a New College</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/ug/dashboard'))">
        <a>College Dashboard</a>
    </li>      
    <li *ngIf="(router.url.includes('main/ug/collegeView'))">
        <a>College Registered List View
        </a>
    </li>   
</ul>
<!-- UIDR -->
<!-- <ul class="breadcrumb" *ngIf="roleName==='SDC'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>  
    <li *ngIf="(router.url.includes('main/internal/uidr/uidrList'))">
        <a>Indian Dentists Register</a>
    </li>     -->
    <!-- <li *ngIf="(router.url.includes('main/internal/uidr/uidrRegistration'))">
        <a>UIDR Registration</a>
    </li>   
    <li *ngIf="(router.url.includes('main/internal/uidr/uidrRenewList') || router.url.includes('main/internal/uidr/UidrEditRenew'))">
        <a>Renew/Update Registration</a>
    </li>   
    <li *ngIf="(router.url.includes('main/internal/uidr/uidrTransferList')|| router.url.includes('main/internal/uidr/transferEdit'))">
        <a>Update Transfer of Registration</a>
    </li>    -->
<!-- </ul> -->
<!-- UIDR -->
<!-- <ul class="breadcrumb" *ngIf="roleName==='Dentist'">
    <li><a routerLink="main/internal/uidr/candidate/uidrList"style="margin-left: 25px;">Home</a></li>  
    <li *ngIf="(router.url.includes('main/internal/uidrcandidate/uidrList'))">
        <a>Existing Registration</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/uidr/uidrRegistration'))">
        <a>UIDR Registration</a>
    </li>    -->
    <!-- <li *ngIf="(router.url.includes('main/internal/uidr/uidrRenewList') || router.url.includes('main/internal/uidr/UidrEditRenew'))">
        <a>Renew/Update Registration</a>
    </li>   
    <li *ngIf="(router.url.includes('main/internal/uidr/uidrTransferList')|| router.url.includes('main/internal/uidr/transferEdit'))">
        <a>Update Transfer of Registration</a>
    </li>    -->
<!-- </ul> -->
<!-- UIDR Section-->
<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/uidr')) &&  (roleName==='ARPMSecInCharge' ||  roleName === 'ARPMAsstSecty' ||  roleName === 'UIDR')">
    <li><a routerLink="../../main/internal/dashboard"style="margin-left: 25px;">Home</a></li>  
    <li *ngIf="(router.url.includes('main/internal/uidr/sectionDashboard'))">
        <a>Indian Dentists Register </a>
    </li>
    <li *ngIf="(router.url.includes('main/uidr/uidrView'))">
        <a>UIDR Details View </a>
    </li>     
</ul>

<!-- grievance -->


<!-- MDM -->
<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/mdm/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>   
    <li *ngIf="(router.url.includes('main/internal/mdm/common/countryMaster'))">
        <a>Country Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/countryAdd'))">
        <a>Country Master Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/stateMaster'))">
        <a>State Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/stateAdd'))">
        <a>State Master Add</a>
    </li>     
    <li *ngIf="(router.url.includes('main/internal/mdm/common/cityMaster'))">
        <a>City Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/cityAdd'))">
        <a>City Master Add</a>
    </li>  
    <li *ngIf="(router.url.includes('main/internal/mdm/common/courseMaster'))">
        <a>Course Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/courseAdd'))">
        <a>Course Master Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/ministry'))">
        <a>Ministry Details</a>
    </li>      
    <li *ngIf="(router.url.includes('main/internal/mdm/common/employeesMaster'))">
        <a>DCI Officers/Employees List</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/employeesAdd'))">
        <a>DCI Officers/Employees Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/collegeMaster'))">
        <a>College Master List</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/collegeAdd'))">
        <a>College Add</a>
    </li>   
    <li *ngIf="(router.url.includes('main/internal/mdm/common/collegeUserList'))">
        <a>College Representative List</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/collegeUserAdd'))">
        <a>College Representative Add</a>
    </li>   
    <li *ngIf="(router.url.includes('main/internal/mdm/common/dmeMaster'))">
        <a>DME Master List</a>
    </li>  
     <li *ngIf="(router.url.includes('main/internal/mdm/common/counsellingAuthorityAdd'))">
        <a>Counselling Authority Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/counsellingAuthorityMaster'))">
        <a>Counselling Authority List</a>
    </li>  
    <li *ngIf="(router.url.includes('main/internal/mdm/common/healthSecretaryAdd'))">
        <a>Health Secretary Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/healthSecretaryMaster'))">
        <a>Health Secretary List</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/advocateAdd'))">
        <a>Advocate Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/advocateMaster'))">
        <a>Advocate List</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/gbMemberAdd'))">
        <a>GB Member Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/gbMemberMaster'))">
        <a>GB Member List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/ecMemberAdd'))">
        <a>EC Member Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/ecMemberMaster'))">
        <a>EC Member List</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/dmeAdd'))">
        <a>DME Master Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/universityMaster'))">
        <a>University Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/universityAdd'))">
        <a>University Master Add</a>
    </li> 
    <li *ngIf="(router.url.includes('main/internal/mdm/common/departmentMaster'))">
        <a>Department Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/departmentAdd'))">
        <a>Department Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/designationMaster'))">
        <a>Designation Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/designationAdd'))">
        <a>Designation Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/specialisationMaster'))">
        <a>Specialisation Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/specialisationAdd'))">
        <a>Specialisation Master Add</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/dentistMaster'))">
        <a>Dentist Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/dentistAdd'))">
        <a>Dentist Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/staffTypeMaster'))">
        <a>Staff Category Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/staffTypeAdd'))">
        <a>Staff Category Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/staffMaster'))">
        <a>Staff Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/staffAdd'))">
        <a>Staff Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/sdcMaster'))">
        <a>SDC Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/sdcAdd'))">
        <a>SDC Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/stateBoardMaster'))">
        <a>State Board Master List</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/mdm/common/stateBoardAdd'))">
        <a>State Board Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/common/paymentTest'))">
        <a>Payment Test</a>
    </li>

    <li *ngIf="(router.url.includes('main/internal/inspection/inspMaster/inspType'))">
        <a>Inspection Type  List</a>
    </li>
    
<!-- legal -->

     <li *ngIf="(router.url.includes('main/internal/mdm/legal/courtMaster'))">
         <a>Court Master List</a>
     </li>
     <li *ngIf="(router.url.includes('main/internal/mdm/legal/courtMasterAdd'))">
        <a>Add Details</a>
    </li>
     <li *ngIf="(router.url.includes('main/internal/mdm/legal/courtBenchMaster'))">
        <a>Court Bench Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/courtBenchAdd'))">
        <a>Court Bench Master Add</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/courtTypeMaster'))">
        <a>Court Type Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/courtTypeAdd'))">
        <a>Court Type Master Add</a>
    </li>
     <li *ngIf="(router.url.includes('main/internal/mdm/legal/advocateCategory'))">
        <a>Advocate Category List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/advocateCategoryAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/advocateMaster'))">
        <a>Advocate Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/advocateMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseCategoryMaster'))">
        <a>Case Category Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseCategoryMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseTypeMaster'))">
        <a>Case Type Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseTypeMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/fileMaster'))">
        <a>File Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/fileMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/advocateFeeMaster'))">
        <a>Advocate Fee Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/advocateFeeMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/documnetTemplateMaster'))">
        <a>Document Template Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/documnetTemplateMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseToDoListMaster'))">
        <a>Case To do List Master List</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseToDoListMasterAdd'))">
        <a>Add Details</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseFileManagement'))">
        <a>Case File Management List</a>
    </li>


    


    <!-- <li *ngIf="(router.url.includes('main/internal/mdm/legal/caseFileManagementAdd'))">
        <a>Add Details</a>
    </li> -->
</ul>
<!--   -->

<!--Added by Gokul for Complainant -->
<ul class="breadcrumb" *ngIf="(router.url.includes('grievance/complaint/')) && 
(roleName==='College Principal' || roleName==='General Public' || roleName==='Student')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('grievance/complaint/new'))">
        <a routerLink="grievance/complaint/new" routerLinkActive="active">Create New</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/complaint/dashboard'))">
        <a routerLink="grievance/complaint/dashboard" routerLinkActive="active">Complaint Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/complaint/compView'))">
        <a routerLinkActive="active">Complaint View</a>
    </li>
</ul>

<!-- section head  -->
<ul class="breadcrumb" *ngIf="(router.url.includes('grievance/section/')) && (roleName==='PDMSSecInCharge' || roleName==='PDMSAsstSecty' 
|| roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('grievance/section/dashboard'))">
        <a>Complaint Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/section/trackDashboard'))">
        <a>Track Complaint Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/section/compView'))">
        <a>Complaint View</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/section/trackCompView'))">
        <a>Track Complaint View</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/section/createAgenda/'))">
        <a>Create Agenda</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/section/viewAgenda/'))">
        <a>View Agenda</a>
    </li>
    <li *ngIf="(router.url.includes('grievance/section/history'))">
        <a>Complaint Process History</a>
    </li>
</ul>

<!-- EC Module  -->
<ul class="breadcrumb" *ngIf="(router.url.includes('excu/sectionHead/')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty'  || roleName==='MSAsstSecty')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    
    <li *ngIf="(router.url.includes('excu/sectionHead/agendaDashBoard')) || (router.url.includes('/excu/sectionHead/viewAgendaDetails')) || (router.url.includes('/excu/sectionHead/agendaProcessHistoryDetails')) || (router.url.includes('/excu/sectionHead/editAgendaDetails'))">
        <a routerLinkActive="active">Agenda DashBoard</a>
    </li>

    <li *ngIf="(router.url.includes('excu/sectionHead/completedMeetingSectionheadDashboard')) || (router.url.includes('/excu/sectionHead/completedMeetingAgendaListComponent')) || (router.url.includes('/excu/sectionHead/viewCompletedAgenda'))">
        <a routerLinkActive="active">Completed Meeting</a>
    </li>

    <li *ngIf="(router.url.includes('excu/sectionHead/exportPdfAgendaList')) || (router.url.includes('/excu/sectionHead/exportPdfAgendaView'))">
        <a routerLinkActive="active">PDF/Print Agenda</a>
    </li>

    <li *ngIf="(router.url.includes('excu/sectionHead/trackAgendaList')) || (router.url.includes('/excu/sectionHead/trackAgendaView')) || (router.url.includes('excu/sectionHead/trackagendaProcessHistoryDetails'))">
        <a routerLinkActive="active">Track Agenda</a>
    </li>
</ul>

<!-- EC Module  -->
<ul class="breadcrumb" *ngIf="(router.url.includes('excu/sectionExcutive/')) && (roleName==='AFExecutive' || roleName==='RTIExecutive'|| roleName==='AcademicExecutive' || roleName==='ServerSecExecutive' ||  roleName==='PDMSExecutive' || roleName==='Assistant Secretary' 
|| roleName==='AcademicSectionOfficer' || roleName === 'RTISectionOfficer' || roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName==='PDMSSectionOfficer' || roleName==='AFSectionOfficer' || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSectionOfficer'
||roleName==='Accountant'||roleName==='AcademicAssistantSectionOfficer' ||roleName==='PDMSAssistantSectionOfficer' || roleName === 'ARPMAssistantSectionOfficer' || roleName === 'RTIAssistantSectionOfficer' || roleName === 'AEAssistantSectionOfficer' ||roleName==='LegalExecutive'
||roleName==='LegalAssistantSectionOfficer'||roleName==='AESectionofficer'|| roleName==='AEExecutive'||roleName==='AESectionofficer' ||roleName==='AFAssistantSectionOfficer' || roleName ==='AEAssistantSecretary'||roleName ==='AcademicAsstSecty'||roleName==='ARPMAsstSecty'||roleName==='PDMSAsstSecty'||roleName ==='AdmsnAsstSecty'||roleName === 'AdmsnSecExecutive')">
<li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    
<li *ngIf="(router.url.includes('excu/sectionExcutive/secExeAgendaDashBoard')) || (router.url.includes('/excu/sectionExcutive/viewSecExeAgendaDetails')) || (router.url.includes('/excu/sectionExcutive/secExeAgendaProcessHistoryDetails')) || (router.url.includes('/excu/sectionExcutive/editSecExeAgendaDetails'))">
    <a routerLinkActive="active">Agenda DashBoard</a>
</li>


<li *ngIf="(router.url.includes('excu/sectionExcutive/exportPdfAgendaList')) || (router.url.includes('/excu/sectionExcutive/exportPdfAgendaView'))">
    <a routerLinkActive="active">PDF/Print Agenda</a>
</li>

<li *ngIf="(router.url.includes('excu/sectionExcutive/trackAgendaList')) || (router.url.includes('/excu/sectionExcutive/trackAgendaView')) || (router.url.includes('excu/sectionExcutive/trackagendaProcessHistoryDetails'))">
    <a routerLinkActive="active">Track Agenda</a>
</li>

</ul>

<!-- Executive Committee  -->
<ul class="breadcrumb" *ngIf="(router.url.includes('excu/ec/') && roleName==='Executive Committee')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('excu/ec/dashboard'))">
        <a>Dashboard</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/ecagenda'))">
        <a>EC Meeting List</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/maintaindatevenue'))">
        <a> Create New Meeting </a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/eccompletedmeeting')) || (router.url.includes('excu/ec/eccompletedmeetingview')) || (router.url.includes('excu/ec/meetingProcessHistoryDetails')) || (router.url.includes('excu/ec/minutesStatusListComponent')) || (router.url.includes('excu/ec/minutesProcessHistoryDetails'))">
        <a>Completed Meeting </a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/exportPdfAgenda'))">
        <a>PDF/Print EC Agenda </a>
    </li> 

    <li *ngIf="(router.url.includes('excu/ec/downloadmeeting'))">
        <a>Print/Download Minutes</a>
    </li>
    
    <li *ngIf="(router.url.includes('excu/ec/conductmeeting'))">
        <a>Conduct Meeting</a>
    </li>
    
  
    

    <li *ngIf="(router.url.includes('excu/ec/noterecordapologies'))">
        <a>Note & Record Apologies</a>
    </li>
  
    <li *ngIf="(router.url.includes('excu/ec/confirminutes'))">
        <a>Confirm Minutes Meeting</a>
    </li>

    <li *ngIf="(router.url.includes('/Confirm'))">
        <a routerLink="excu/ec/confirminutes" routerLinkActive="active">Confirm Minutes Meeting</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/actiontaken'))">
        <a>Action Taken On Meeting</a>
    </li>
    <li *ngIf="(router.url.includes('excu/ec/policymatter'))">
        <a>Policy Matters</a>
    </li>
    <li *ngIf="(router.url.includes('excu/ec/arplmatter') && !router.url.includes('excu/ec/arplmatterview'))">
        <a>ARPM Matters</a>
    </li>
    <li *ngIf="(router.url.includes('/6/ARPL'))">
        <a routerLink="excu/ec/arplmatter" routerLinkActive="active">ARPM Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/academicmatter'))">
        <a>Academic Matters</a>
    </li>
    <li *ngIf="(router.url.includes('/Academic'))">
        <a routerLink="excu/ec/academicmatter" routerLinkActive="active">Academic Matters</a>
    </li>

    <!-- <li *ngIf="(router.url.includes('excu/ec/ARPMmatter'))">
        <a>ARPM Matters</a>
    </li> -->
    <li *ngIf="(router.url.includes('excu/ec/administrationmatter'))">
        <a>Administration Matters</a>
    </li>

    <li *ngIf="(router.url.includes('/Administration'))">
        <a routerLink="excu/ec/administrationmatter" routerLinkActive="active">Administration Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/accfinancematter'))">
        <a>Account & Finance Matters</a>
    </li>

    
    <li *ngIf="(router.url.includes('/Account'))">
        <a routerLink="excu/ec/accfinancematter" routerLinkActive="active">Account & Finance Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/legalpublicmatter'))">
        <a>Legal/RTI/Public Grievance Matters</a>
    </li>

    
    <li *ngIf="(router.url.includes('/Legal'))">
        <a routerLink="excu/ec/legalpublicmatter" routerLinkActive="active">Legal/RTI/Public Grievance Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/membershipmatter'))">
        <a>Membership Matters</a>
    </li>

    
    <li *ngIf="(router.url.includes('/Membership'))">
        <a routerLink="excu/ec/membershipmatter" routerLinkActive="active">Membership Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/inspectionmatter'))">
        <a>Inspection Matters</a>
    </li>

    
    <li *ngIf="(router.url.includes('/Inspection'))">
        <a routerLink="excu/ec/inspectionmatter" routerLinkActive="active">Inspection Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/pdmmatter'))">
        <a>Para Dentist and Miscellaneous Matters</a>
    </li>

    
    <li *ngIf="(router.url.includes('/PDMS'))">
        <a routerLink="excu/ec/pdmmatter" routerLinkActive="active">Para Dentist and Miscellaneous Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/admissionmatter'))">
        <a>Admission Matters</a>
    </li>

    
    <li *ngIf="(router.url.includes('/Admission'))">
        <a routerLink="excu/ec/admissionmatter" routerLinkActive="active">Admission Matters</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/supplementary'))">
        <a>Supplementary Items</a>
    </li>

    
    <li *ngIf="(router.url.includes('/Supplementary'))">
        <a routerLink="excu/ec/supplementary" routerLinkActive="active">Supplementary Items</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/anyotherbusiness'))">
        <a>Any Other Business</a>
    </li>

    
    <li *ngIf="(router.url.includes('/AOB'))">
        <a routerLink="excu/ec/anyotherbusiness" routerLinkActive="active">Any Other Business</a>
    </li>

    <li *ngIf="(router.url.includes('excu/ec/DateAndVenueNextMeetingComponent'))">
        <a>Date & Venue Next Meeting</a>
    </li>
    <li *ngIf="(router.url.includes('excu/ec/voteofthanks'))">
        <a>Vote of Thanks</a>
    </li>
</ul>
<!-- roleName==='President' -->
<ul class="breadcrumb" *ngIf="(router.url.includes('excu/CZsQVJe0x6/')) && (roleName==='Secretary' || roleName==='Secretary Incharge'|| roleName==='Joint Secretary')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
      
<li *ngIf="(router.url.includes('excu/CZsQVJe0x6/ReviewAgendaComponent')) || (router.url.includes('/excu/CZsQVJe0x6/ReviewAgendaViewComponent')) || (router.url.includes('/excu/CZsQVJe0x6/agendaProcessHistoryDetails'))">
    <a routerLinkActive="active">Review Agenda Item</a>
</li>

<li *ngIf="(router.url.includes('excu/CZsQVJe0x6/ReviewMinutesComponent')) || (router.url.includes('/excu/CZsQVJe0x6/ReviewMinutesViewComponent')) || (router.url.includes('/excu/CZsQVJe0x6/minutesProcessHistoryDetails'))">
    <a routerLinkActive="active">Review Minutes</a>
</li>

<li *ngIf="(router.url.includes('excu/CZsQVJe0x6/ReviewMeetingComponent')) || (router.url.includes('/excu/CZsQVJe0x6/ReviewMeetingViewComponent')) || (router.url.includes('/excu/CZsQVJe0x6/meetingProcessHistoryDetails'))">
    <a routerLinkActive="active">Completed Meeting</a>
</li>

<li *ngIf="(router.url.includes('excu/CZsQVJe0x6/exportPdfAgendaList')) || (router.url.includes('/excu/CZsQVJe0x6/exportPdfAgendaView'))">
    <a routerLinkActive="active">PDF/Print Agenda</a>
</li>

<li *ngIf="(router.url.includes('excu/CZsQVJe0x6/trackAgendaList')) || (router.url.includes('/excu/CZsQVJe0x6/trackAgendaView')) || (router.url.includes('excu/CZsQVJe0x6/trackagendaProcessHistoryDetails'))">
    <a routerLinkActive="active">Track Agenda</a>
</li>

<li *ngIf="(router.url.includes('excu/CZsQVJe0x6/trackMinutesList')) || (router.url.includes('/excu/CZsQVJe0x6/trackMinutesView')) || (router.url.includes('excu/CZsQVJe0x6/trackMinutesProcessHistoryDetails'))">
    <a routerLinkActive="active">Track Minutes</a>
</li>

</ul>
<ul class="breadcrumb" class="breadcrumb" *ngIf="(router.url.includes('excu/president/')) && (roleName==='President')">
<li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>

  
<li *ngIf="(router.url.includes('excu/president/presidentReviewAgendaComponent')) || (router.url.includes('/excu/president/presidentReviewAgendaViewComponent')) || (router.url.includes('/excu/president/agendaProcessHistoryDetails'))">
    <a routerLinkActive="active">Review Agenda Item</a>
</li>

<li *ngIf="(router.url.includes('excu/president/presidentReviewMinutesComponent')) || (router.url.includes('/excu/president/presidentReviewMinutesViewComponent')) || (router.url.includes('/excu/president/minutesProcessHistoryDetails'))">
    <a routerLinkActive="active">Review Minutes</a>
</li>

<li *ngIf="(router.url.includes('excu/president/presidentReviewMeetingComponent')) || (router.url.includes('/excu/president/presidentReviewMeetingViewComponent')) || (router.url.includes('/excu/president/meetingProcessHistoryDetails'))">
    <a routerLinkActive="active">Completed Meeting</a>
</li>

<li *ngIf="(router.url.includes('excu/president/exportPdfAgendaList')) || (router.url.includes('/excu/president/exportPdfAgendaView'))">
    <a routerLinkActive="active">PDF/Print Agenda</a>
</li>

<li *ngIf="(router.url.includes('excu/president/trackAgendaList')) || (router.url.includes('/excu/president/trackAgendaView')) || (router.url.includes('excu/president/trackagendaProcessHistoryDetails'))">
    <a routerLinkActive="active">Track Agenda</a>
</li>

<li *ngIf="(router.url.includes('excu/president/trackMinutesList')) || (router.url.includes('/excu/president/trackMinutesView')) || (router.url.includes('excu/president/trackMinutesProcessHistoryDetails'))">
    <a routerLinkActive="active">Track Minutes</a>
</li>


</ul>

<!-- Inspection Moodule  -->
<!-- Inspection Cell  inspectionresponse-->
<ul class="breadcrumb" *ngIf="((router.url.includes('inspection/insCell/')) || (router.url.includes('inspection/inspMaster/'))) && 
(roleName==='InspectionCell' || roleName==='InspAsstSecty'|| roleName==='Chairperson'|| roleName==='Inspection Executive' || roleName==='System Admin' || roleName==='AcademicIncharge' || roleName==='AcademicAsstSecty' || roleName==='AcademicSectionOfficer' || roleName==='AcademicAssistantSectionOfficer' || roleName==='AcademicExecutive' || roleName==='System Admin' || roleName==='Secretary' || roleName==='Secretary Incharge'|| roleName==='President'|| roleName==='ServerSecExecutive'
|| roleName==='PDMSSectionOfficer'|| roleName==='PDMSAssistantSectionOfficer'|| roleName==='PDMSExecutive'|| roleName==='PDMSSecInCharge'|| roleName==='PDMSAsstSecty'|| roleName==='Joint Secretary')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('inspection/insCell/inspectorMaster'))">
        <a routerLinkActive="active">Inspector List</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/avalInspectors'))">
        <a routerLinkActive="active">Available Inspector Details</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/inspectorutilizationreport'))">
        <a routerLinkActive="active">Inspector Utilization Report</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/exaustedInspectorPool'))">
        <a routerLinkActive="active">Exhausted inspector pool</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/inspectorAdd'))">
        <a routerLinkActive="active">Inspector View</a>
    </li>
    <li *ngIf="router.url.includes('inspection/insCell/createIns') || router.url.includes('inspection/insCell/inspecSheduleEdit')">
        <a routerLinkActive="active">Inspection scheduling</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/manageinspec')) || (router.url.includes('inspection/insCell/inspList'))
    || (router.url.includes('inspection/insCell/newmanageinspec'))|| (router.url.includes('inspection/insCell/newinspList'))">
        <a routerLinkActive="active">Manage Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/trackInspList'))  || (router.url.includes('inspection/insCell/newtrackInspList'))">
        <a routerLinkActive="active">Track Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/concludeInspList')) || (router.url.includes('inspection/insCell/newconcludeInspList'))">
        <a routerLinkActive="active">Conclude Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/appointedInspectorsList'))">
        <a routerLinkActive="active">Appointed Inspectors</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/history')) || (router.url.includes('inspection/insCell/newhistory'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/manageinspec/inspectionresponse')) || (router.url.includes('inspection/insCell/newmanageinspec/inspectionresponse'))">
        <a routerLinkActive="active">Manage
            Inspection View</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/completedinspec'))">
        <a routerLinkActive="active">Team Formed</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/completedinspec/inspectionresponse'))">
        <a routerLinkActive="active">
            Team Formed View</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/cancelledinspec'))">
        <a routerLinkActive="active">Cancelled Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/cancelledinspec/inspectionresponse'))">
        <a routerLinkActive="active">
            Cancelled Inspection View</a>
    </li>

    <li *ngIf="(router.url.includes('inspection/insCell/insreport'))">
        <a routerLinkActive="active">Inspection Report</a>
    </li>
    <!-- <li *ngIf="(router.url.includes('inspection/insCell/insreport/proformagridview'))">
        <a routerLink="inspection/insCell/insreport/proformagridview" routerLinkActive="active">
            Inspection Report View</a>
    </li> -->
    <li *ngIf="(router.url.includes('inspection/inspMaster/holiday'))">
        <a routerLinkActive="active">Holiday Master</a>
    </li>
    <li *ngIf="(router.url.includes('/inspection/inspMaster/collegeholiday'))">
        <a routerLinkActive="active">College Holiday Master</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspMaster/inspType'))">
        <a routerLinkActive="active">Inspection Type</a>
    </li> 
    <li *ngIf="(router.url.includes('inspection/inspMaster/inspTypeAdd'))">
        <a routerLinkActive="active">Inspection Type Add</a>
    </li> 
    <li *ngIf="(router.url.includes('inspection/inspMaster/inspSubType'))">
        <a routerLinkActive="active">Inspection Sub Type</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspMaster/inspPurpose'))">
        <a routerLinkActive="active">Inspection Purpose</a>
    </li>
</ul>

<!-- Travel Agent  -->
<ul class="breadcrumb"*ngIf="(router.url.includes('inspection/insCell/')) && roleName==='AFSectionOfficer'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
   
    <li *ngIf="(router.url.includes('/inspection/insCell/travelagentclaim'))">
        <a routerLinkActive="active">Claim List</a>
    </li>

    <li *ngIf="(router.url.includes('/inspection/insCell/travelagentclaim/travelclaimview'))">
        <a routerLinkActive="active">Claim View</a>
    </li>
</ul>

<!-- Travel Agent  -->
<ul class="breadcrumb" *ngIf="roleName==='TravelAgent'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('inspection/tavelagent/shedule'))">
        <a routerLinkActive="active">Bookings List</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/tavelagent/allClaims'))">
        <a routerLinkActive="active">Claim Status</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/tavelagent/allClaims/viewshedule'))">
        <a routerLinkActive="active">Claim Status View</a>
    </li>
    <!-- <li *ngIf="(router.url.includes('inspection/tavelagent/shedule/viewshedule/uploaddetails'))">
        <a routerLink="inspection/tavelagent/shedule/viewshedule/:id/uploaddetails" routerLinkActive="active">Upload Booking Details</a>
    </li> -->
    <li *ngIf="(router.url.includes('inspection/tavelagent/dashboard'))">
        <a routerLinkActive="active">Dashboard</a>
    </li>
    <li *ngIf="router.url.includes('inspection/insCell/createIns') || router.url.includes('inspection/insCell/inspecSheduleEdit')">
        <a routerLinkActive="active">Inspection scheduling</a>
    </li>
    <li *ngIf="router.url.includes('inspection/insCell/manageinspec') || router.url.includes('inspection/insCell/inspList')">
        <a routerLinkActive="active">Manage Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/trackInspList'))">
        <a routerLinkActive="active">Track Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/concludeInspList'))">
        <a routerLinkActive="active">Conclude Inspection</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/history'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/insCell/manageinspec/inspectionresponse'))">
        <a routerLinkActive="active">Manage
            Inspection View</a>
    </li>
</ul>

<!-- inspectionproforma added by gokul  -->

<ul class="breadcrumb"*ngIf="(router.url.includes('inspection/inspectionproforma/')) && roleName==='Inspector'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>   
    <li>
        <a routerLinkActive="active">Inspection proforma</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/collegeInformation'))">
        <a routerLinkActive="active">College Information</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/generalInformation'))">
        <a routerLinkActive="active">General Information</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/libraryDetails'))">
        <a routerLinkActive="active">Library Details</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/hostelFacility'))">
        <a routerLinkActive="active">Hostel Facility for PG</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/teachingStaff'))">
        <a routerLinkActive="active">Teaching Staff</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/equipments'))">
        <a routerLinkActive="active">Equipments</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/infrastructure'))">
        <a routerLinkActive="active">Infrastructure Details</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/staffAssessmentPublications'))">
        <a routerLinkActive="active">Staff Assessment for Publications</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/lastAnnualAdmissionSpecialty'))">
        <a routerLinkActive="active">Last Annual Admission details for Specialty</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/clinicalWorkLoad'))">
        <a routerLinkActive="active">Clinical Work Load</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/studentAcademicDashboard'))">
        <a routerLinkActive="active">Student Academic Presentation</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/teachingLearningActivitiesDashboard'))">
        <a routerLinkActive="active">Teaching/Learning Activities</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/deficiencyReport'))">
        <a routerLinkActive="active">Deficiency Report</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/inspectionReport'))">
        <a routerLinkActive="active">Inspection Report</a>
    </li>
    <li *ngIf="(router.url.includes('inspection/inspectionproforma/submitInspection'))">
        <a routerLinkActive="active">Submit Inspection</a>
    </li>
</ul>

<!-- DarkSection Head -->
<ul class="breadcrumb" *ngIf="router.url.includes('inbound/diarydakincharge/') && (roleName==='RDSecInCharge' || roleName==='R&DSecExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/receiptDashboard'))">
        <a routerLinkActive="active">R & D Section Receipt
            Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/trackReceiptDashboard'))">
        <a routerLinkActive="active">R & D Section Track Receipt
            </a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/createReceipt') &&  !router.url.includes('/main/internal/inbound/diarydakincharge/createReceipt;id='))">
        <a>Create Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/createReceipt;id='))">
        <a>Update Receipt</a>

    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/ViewReceipt;id='))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/trackViewReceipt;id='))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/dispatchdashboard'))">
        <a routerLinkActive="active">R & D Section Dispatch Dashboard
            </a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/inbound/diarydakincharge/acknowledgementdashboard'))">
        <a routerLinkActive="active">R & D Section Acknowledgement Dashboard
            </a>
    </li>



</ul>
<!-- ARPM SectionExecutive -->
<ul class="breadcrumb" *ngIf="!(router.url.includes('outbound/se/ssahistory')) && (router.url.includes('outbound/secInch/')||router.url.includes('inbound/diarydakincharge/')||router.url.includes('outbound/se/')||router.url.includes('inbound/sectionexecutive'))
 && (roleName==='ARPMSecExecutive' || roleName==='Student Admission Executive' || roleName==='AdmsnSecExecutive'  
 || roleName === 'AcademicExecutive' || roleName==='ServerSecExecutive' || roleName === 'PDMSExecutive' || roleName === 'AEExecutive'
 || roleName === 'AcademicSectionOfficer'|| roleName === 'AcademicSectionOfficer' || roleName === 'RTISectionOfficer' || roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer'
 || roleName === 'PDMSSectionOfficer' || roleName === 'Accountant' || roleName === 'AcademicAssistantSectionOfficer' || roleName === 'PDMSAssistantSectionOfficer' || roleName === 'ARPMAssistantSectionOfficer' || roleName === 'AEAssistantSectionOfficer' 
 || roleName === 'RTIAssistantSectionOfficer' || roleName === 'AESectionofficer' || roleName === 'LegalRetainer' || roleName==='RTILegalRetainer' || roleName === 'LegalSectionOfficer'
  || roleName === 'AFSectionOfficer' || roleName === 'AFAssistantSectionOfficer' || roleName === 'AFExecutive'
  || roleName === 'LegalExecutive' || roleName === 'LegalAssistantSectionOfficer' || roleName === 'RTIExecutive'||roleName === 'DAK_Section_Executive'
  || roleName ==='AEAssistantSecretary'||roleName ==='AcademicAsstSecty'||roleName==='ARPMAsstSecty'||roleName==='PDMSAsstSecty'||roleName ==='AdmsnAsstSecty') ">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/se/dashboard'))">
        <a routerLinkActive="active">Note Sheet Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/createNoteSheet'))">
        <a>Put Up Note Sheet</a>
    </li>
    <li *ngIf="((router.url.includes('/outbound/secInch/viewSheetData')) || (router.url.includes('/outbound/se/viewTracksheetSecExec')) || (router.url.includes('/outbound/se/view')) || (router.url.includes('/inbound/sectionexecutive/otherSecView'))) && !(router.url.includes('outbound/se/viewSecExecClarification'))">
        <a>Note Sheet View</a>
    </li>    
    <li *ngIf="(router.url.includes('/outbound/se/correctionList'))">
        <a>Correct Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/secInch/fileStructureSubCategory'))">
        <a>Sub Category</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/secInch/fileStructureFileReference'))">
        <a>File Reference</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/dispatchDashboard'))">
        <a>Dispatch Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/correctionView'))">
        <a>Correction View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/trackNotesheetSecExec'))">
        <a>Track Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/dashboard'))">
        <a routerLinkActive="active">Receipt Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/trackDashboard'))">
        <a routerLinkActive="active">Track Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/acknowledgementDashboard'))">
        <a routerLinkActive="active">Acknowledgement Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreport'))">
        <a routerLinkActive="active">File Directory</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreportview'))">
        <a routerLinkActive="active">File List</a>
    </li>

    <li *ngIf="(router.url.includes('outbound/secInch/viewnotesheetData'))">
        <a routerLinkActive="active">View Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewreceiptData'))">
        <a routerLinkActive="active">View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/otherSecDispatches'))">
        <a routerLinkActive="active">Other Section Dispatches
        </a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/view-receipt'))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/view-track-receipt'))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/secExeClarificationList'))">
        <a>Received from Other Section(s)</a>
    </li>    
    <li *ngIf="(router.url.includes('outbound/se/viewSecExecClarification'))">
        <a>View Detail</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/trackreceiptview'))">
        <a>View Receipt</a>
    </li> 
    <li *ngIf="(router.url.includes('/outbound/se/createAgenda'))">
        <a>Create Agenda</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/viewAgenda'))">
        <a>View Agenda</a>
    </li>
</ul>

<!-- ARPM SectionExecutive -->
<!-- ARPM SectionIncharge -->

<ul class="breadcrumb" *ngIf="!(router.url.includes('outbound/se/ssahistory')) && (((router.url.includes('inbound/sectionexecutive')) || (router.url.includes('outbound/secInch'))|| (router.url.includes('inbound/diarydakincharge')) || (router.url.includes('outbound/se'))) || router.url.includes('inbound/sectionincharge')) && (roleName==='AdmsnIncharge' || roleName==='AcademicIncharge' || roleName === 'AFSecInCharge' ||
roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName === 'AEIncharge' || roleName ==='LegalSecInCharge'||roleName ==='ISecInCharge'|| 
roleName === 'InspAsstSecty' || roleName==='MSAsstSecty'||roleName ==='RTISecInCharge' 
|| roleName==='ServerSecInCharge')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/secInch/IncDashboard'))">
        <a routerLinkActive="active">Note Sheet Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewSheetData')) || (router.url.includes('/outbound/se/viewDispatch')) || (router.url.includes('/inbound/sectionincharge/otherSecView')) || (router.url.includes('/outbound/se/viewreceiptse'))">
        <a>Note Sheet View</a>
    </li> 
    <li *ngIf="(router.url.includes('outbound/secInch/correctionList'))">
        <a>Correct Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/secInchDispatchDashboard'))">
        <a>Dispatch Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/correctionView/'))">
        <a>Correction View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/trackNotesheet'))">
        <a>Track Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionincharge/receiptDashboard'))">
        <a routerLinkActive="active">Receipt Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionincharge/trackReceiptDashboard'))">
        <a routerLinkActive="active">Track Receipt </a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionincharge/acknDashboard'))">
        <a routerLinkActive="active">Acknowledgement Dashboard </a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/dashboard'))">
        <a routerLinkActive="active">Receipt Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/trackDashboard'))">
        <a routerLinkActive="active">Track Receipt</a>
    </li>
    <!-- <li *ngIf="(router.url.includes('inbound/sectionexecutive/acknowledgementDashboard'))">
        <a routerLinkActive="active">Acknowledgement Dashboard</a>
    </li> -->
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreport'))">
        <a routerLinkActive="active">File Directory</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreportview'))">
        <a routerLinkActive="active">File List</a>
    </li>

    <li *ngIf="(router.url.includes('outbound/secInch/viewnotesheetData'))">
        <a routerLinkActive="active">View Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewreceiptData'))">
        <a routerLinkActive="active">View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionincharge/OtherSecDispatch'))">
        <a routerLinkActive="active">Other Section Dispatches</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionincharge/view-receipt'))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/view-receipt'))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionincharge/view-track-receipt'))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/sectionexecutive/view-track-receipt'))">
        <a>View Receipt</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/historyNotesheet'))">
        <a>Notesheet History</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/sectionClarification'))">
        <a>Received from Other Section(s)</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/secExeClarificationList'))">
        <a>Received from Other Section(s)</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/viewSecExecClarification'))">
        <a>View Detail</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewClarification'))">
        <a>View Detail</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/viewTracksheetSecExec'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/secInch/viewTrackSheet'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/correctionList'))">
        <a>Correct Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/secInch/fileStructureSubCategory'))">
        <a>Sub Category</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/secInch/fileStructureFileReference'))">
        <a>File Reference</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/dispatchDashboard'))">
        <a>Dispatch Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/correctionView'))">
        <a>Correction View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/trackNotesheetSecExec'))">
        <a>Track Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/secExeClarificationList'))">
        <a>Received from Other Section(s)</a>
    </li>    
    <li *ngIf="(router.url.includes('outbound/se/viewSecExecClarification'))">
        <a>View Detail</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/dashboard'))">
        <a routerLinkActive="active">Note Sheet Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/createNoteSheet'))">
        <a>Put Up Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/viewTracksheetSecExec'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/trackreceiptview'))">
        <a>View Receipt</a>
    </li> 
    <li *ngIf="(router.url.includes('outbound/secInch/viewsectionincharge'))">
        <a>View Receipt</a>
    </li> 
</ul>
<!-- ARPM SectionIncharge -->

<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/secInch/viewClarificationComments'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewClarificationComments'))">
        <a>View Detail</a>
    </li>
</ul>

<!-- Joint Secretary/Secretary -->
<ul class="breadcrumb" *ngIf="!(router.url.includes('outbound/se/ssahistory')) && ((router.url.includes('outbound/CZsQVJe0x6/'))||(router.url.includes('outbound/secInch/'))||(router.url.includes('inbound/diarydakincharge/')) || (router.url.includes('outbound/se/'))) && (roleName==='Joint Secretary' || roleName==='Secretary' || roleName==='Secretary Incharge')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/CZsQVJe0x6/dashboard'))">
        <a routerLinkActive="active">Note Sheet Dashboard</a>
    </li>
    <!-- <li *ngIf="(router.url.includes('outbound/secretary/acknDashboard'))">
        <a routerLinkActive="active">Acknowledgement Dashboard</a>
    </li> -->
    <li *ngIf="(router.url.includes('outbound/CZsQVJe0x6/sheetView/'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/viewDispatch'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/CZsQVJe0x6/otherSecDispatches'))">
        <a>Other Section Dispatches</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/CZsQVJe0x6/dispatchDashboard'))">
        <a>Dispatch Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/trackNotesheetSecExec'))">
        <a>Track Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/viewTracksheetSecExec'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/viewreceiptse'))">
        <a>Note Sheet View</a>
    </li> 
    <li *ngIf="(router.url.includes('outbound/CZsQVJe0x6/secrtaryview'))">
        <a>View Receipt</a>
    </li> 
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreport'))">
        <a routerLinkActive="active">File Directory</a>
    </li>
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreportview'))">
        <a routerLinkActive="active">File List</a>
    </li>

    <li *ngIf="(router.url.includes('outbound/secInch/viewnotesheetData'))">
        <a routerLinkActive="active">View Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewreceiptData'))">
        <a routerLinkActive="active">View Receipt</a>
    </li>
</ul>
<!-- President -->
<ul class="breadcrumb" *ngIf="!(router.url.includes('outbound/se/ssahistory')) && (router.url.includes('outbound/se/')||router.url.includes('outbound/president/')||router.url.includes('inbound/diarydakincharge')||router.url.includes('outbound/secInch')) &&roleName==='President'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/president/dashboard'))">
        <a routerLinkActive="active">Note Sheet Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/president/sheetView/'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('/outbound/se/viewDispatch'))">
        <a>Note Sheet View</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/president/dispatchDashboard'))">
        <a>Dispatch Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/trackNotesheetSecExec'))">
        <a>Track Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/se/viewTracksheetSecExec'))">
        <a>Note Sheet View</a>
    </li> 
    <li *ngIf="(router.url.includes('outbound/se/viewreceiptse'))">
        <a>Note Sheet View</a>
    </li> 
    <li *ngIf="(router.url.includes('outbound/president/presidentView'))">
        <a>View Receipt</a>
    </li> 
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreport'))">
        <a routerLinkActive="active">File Directory</a>
    </li>
    
    <li *ngIf="(router.url.includes('inbound/diarydakincharge/diarydakreportview'))">
        <a routerLinkActive="active">File List</a>
    </li>

    <li *ngIf="(router.url.includes('outbound/secInch/viewnotesheetData'))">
        <a routerLinkActive="active">View Note Sheet</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/secInch/viewreceiptData'))">
        <a routerLinkActive="active">View Receipt</a>
    </li>
</ul>
<!-- history -->
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/se/ssahistory/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/se/ssahistory/'))">
        <a>Chronological History</a>
    </li>
</ul>
<!-- history -->
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/history/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/history/'))">
        <a>Chronological History</a>
    </li>
</ul>
<!-- history -->
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/historyy/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/historyy/'))">
        <a>Chronological History</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/dispatch/history/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/dispatch/history/'))">
        <a>Chronological History</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/otherSectionHistory/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/otherSectionHistory'))">
        <a>Chronological History</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/viewDispatch/otherSection/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/viewDispatch/otherSection/'))">
        <a>Reference NoteSheet</a>
    </li>
</ul>
<!-- Quaterly Report -->
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/quaterlyReport'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/quaterlyReport'))">
        <a>Quaterly Report</a>
    </li>
</ul>
<!-- history -->
<!-- DAK Section Executive -->
<ul class="breadcrumb" *ngIf="(router.url.includes('outbound/diarydaksechead')) && roleName==='DAK_Section_Executive'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('outbound/diarydaksechead/dashboard'))">
        <a routerLinkActive="active">Dispatch Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('outbound/diarydaksechead/viewDispatch'))">
        <a>Dispatch View</a>
    </li>
</ul>

<!-- Student Admission -->

<!-- Student Admission -->
<!-- College Principal -->
<ul class="breadcrumb" *ngIf="(router.url.includes('college/dean/')) && (roleName==='College Principal' || roleName === 'AdmsnSectionOfficer' 
|| roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/dean/studentsList')) && roleName==='College Principal'">
        <a routerLinkActive="active">Students List</a>
    </li>
    <li *ngIf="(router.url.includes('college/dean/view'))">
        <a>View</a>
    </li>

    <li *ngIf="(router.url.includes('college/dean/addStudentForm'))">
        <a>Student Admission</a>
    </li>
    <!-- <li *ngIf="(router.url.includes('college/dean/addStudentForm;id'))">
        <a>Edit Student</a>
    </li> -->
    <li *ngIf="(router.url.includes('college/dean/clarificationList'))">
        <a>Clarification List</a>
    </li>
    <li *ngIf="(router.url.includes('college/dean/approveStudentsList'))">
        <a>Active Students List</a>
    </li>
    <li *ngIf="(router.url.includes('college/dean/dischargeStudentsList'))">
        <a>Discharged Students List</a>
    </li>

</ul>

<!-- history -->
<ul class="breadcrumb" *ngIf="(router.url.includes('/main/internal/college/admissionMonitorCellExecutive/process-history/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/college/admissionMonitorCellExecutive/process-history/'))">
        <a>Status History</a>
    </li>
</ul>
<!-- Create Agenda -->
<ul class="breadcrumb" *ngIf="(router.url.includes('/main/internal/college/admissionMonitorCellExecutive/createAgenda/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/college/admissionMonitorCellExecutive/createAgenda/'))">
        <a>Create Agenda</a>
    </li>
</ul>
<!-- View Agenda -->
<ul class="breadcrumb" *ngIf="(router.url.includes('/main/internal/college/admissionMonitorCellExecutive/viewAgenda/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/college/admissionMonitorCellExecutive/viewAgenda/'))">
        <a>View Agenda</a>
    </li>
</ul>
<!-- College Principal Course Completion -->
<ul class="breadcrumb" *ngIf="(router.url.includes('college/collegeRep/')) &&roleName==='College Principal'">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/collegeRep/coursecompletionStudentList'))">
        <a routerLinkActive="active">Promote a Student</a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeRep/view'))">
        <a>View</a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeRep/coursecompletionForm'))">
        <a>Complete Course of a Student</a>
    </li>
</ul>
<!-- Student Admission Executive -->
<ul class="breadcrumb" *ngIf="((router.url.includes('college/admissionMonitorCellExecutive/collegelist')) || (router.url.includes('college/admissionMonitorCellExecutive/viewStudentsList')) || (router.url.includes('college/admissionMonitorCellExecutive/viewStudentDetails'))) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/collegelist'))">
        <a routerLinkActive="active">College List</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewStudentsList'))">
        <a>Students For The College</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewStudentDetails'))">
        <a>View</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/agendaList'))">
        <a>Agenda List</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/agendaView'))">
        <a>View Agenda</a>
    </li>
</ul>


<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/studentSearch')) && (roleName==='Student Admission Executive' || roleName==='AdmsnSectionOfficer' 
|| roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnIncharge' 
|| roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/studentSearch'))">
        <a routerLinkActive="active">Student Search</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/collegeSearch')) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/collegeSearch'))">
        <a routerLinkActive="active">College Search</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/collegeOfferedSpec')) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/collegeOfferedSpec'))">
        <a routerLinkActive="active">College Offered Course Spec</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="((router.url.includes('college/admissionMonitorCellExecutive/criteriaList')) || 
(router.url.includes('college/admissionMonitorCellExecutive/criteriaAdd')) || (router.url.includes('college/admissionMonitorCellExecutive/criteriaHistory'))) 
&& (roleName==='Student Admission Executive' || roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/criteriaList'))">
        <a routerLinkActive="active">Student Passing Criteria List</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/criteriaAdd'))">
        <a routerLinkActive="active">Student Passing Criteria View</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/criteriaHistory'))">
        <a routerLinkActive="active">Passing Criteria Process History</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/admissionPeriod'))||(router.url.includes('college/admissionMonitorCellExecutive/viewAdmissionPeriod')) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/admissionPeriod'))">
        <a routerLinkActive="active">Student Admission Period List</a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewAdmissionPeriod'))">
        <a routerLinkActive="active">Student Admission Period View</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/noteSheetContentView'))||((router.url.includes('college/admissionMonitorCellExecutive/noteSheetContentList')) || (router.url.includes('college/admissionMonitorCellExecutive/noteSheetContentAdd'))) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/noteSheetContentList'))">
        <a routerLinkActive="active">Note Sheet Subject/Contents </a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/noteSheetContentAdd'))">
        <a routerLinkActive="active">Note Sheet Subject/Contents </a>
    </li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/noteSheetContentView'))">
        <a routerLinkActive="active">Note Sheet Subject/Contents View</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/seatsReport')) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/seatsReport'))">
        <a routerLinkActive="active">Permitted/Admitted/Vacant Seats</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/studentReport')) && (roleName==='Student Admission Executive' 
|| roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/studentReport'))">
        <a routerLinkActive="active">Student Report Details</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/counsellingMaster')) && ( roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/counsellingMaster'))">
        <a routerLinkActive="active">Counselling Authority Master</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/universityMaster')) && ( roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/universityMaster'))">
        <a routerLinkActive="active">University Master</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewcounsellingAuthority')) && ( roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewcounsellingAuthority'))">
        <a routerLinkActive="active">View Counselling Authority </a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewuniversity')) && ( roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' 
|| roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewuniversity'))">
        <a routerLinkActive="active">View University </a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/studentAdmissionDetails')) && (roleName==='CA'|| roleName === 'University')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/studentAdmissionDetails'))">
        <a routerLinkActive="active">Student Admission Details</a>
    </li>
</ul>
<ul class="breadcrumb" *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/StudentAdmissionDetails')) && (roleName==='CA' || roleName === 'University')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/StudentAdmissionDetails'))">
        <a routerLinkActive="active">View </a>
    </li>
</ul>
<!-- Student Admission -->
<!-- Registration Modules Starts-->
<ul class="breadcrumb" *ngIf="(router.url.includes('allregister/'))">
    <li *ngIf="(router.url.includes('allregister/register'))">
        <a></a>
    </li>
    <!-- <li *ngIf="(router.url.includes('allregister/register/ecApplicant/signup'))">
        <a routerLinkActive="active"></a>
    </li> -->
    <li *ngIf="(router.url.includes('allregister/register/fqsrregistration'))">
        <a routerLinkActive="active">Foreign Qualification Screening and Registration (FQSR)</a>
    </li>
    <li *ngIf="(router.url.includes('allregister/register/student'))">
        <a routerLinkActive="active">User Registration</a>
    </li>
</ul>
<!-- Registration Modules Ends-->

<!-- Eligibility Certiicate Module Starts-->
<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/eligibility/')) && (roleName === 'Student' || roleName === 'PDMSSecInCharge' 
|| roleName === 'PDMSAsstSecty' || roleName === 'PDMSSectionOfficer' 
|| roleName === 'PDMSAssistantSectionOfficer' || roleName === 'PDMSExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/raisenewrequest'))">
        <a routerLinkActive="active">Raise New Request</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/request'))">
        <a routerLinkActive="active">Eligibility Certificate Application</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/dashboard'))">
        <a routerLinkActive="active">Eligibility Certificate Dashboard</a>
    </li>    
    <li *ngIf="(router.url.includes('main/internal/eligibility/eccandiateview'))">
        <a routerLinkActive="active">Eligibility Certificate View</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/secDashboard'))">
        <a routerLinkActive="active">Eligibility Certificate Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/secTrackDashboard'))">
        <a routerLinkActive="active">Eligibility Certificate Track Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/secView'))">
        <a routerLinkActive="active">Eligibility Certificate View</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/history'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/eligibility/referenceView'))">
        <a routerLinkActive="active">Reference View</a>
    </li>
</ul>
<!-- Eligibility Certiicate Module ENDS-->

<!-- Anti-Ragging Module  === College Principel-->
<ul class="breadcrumb" *ngIf="router.url.includes('/main/internal/antiRagging') && (roleName==='College Principal' || roleName==='College Principal')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/antiRagging/antiRaggingDashboard'))">
        <a routerLinkActive="active">
            Anti-Ragging Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/antiRagging/antiRaggingAdd'))">
        <a routerLinkActive="active">Anti-Ragging Add</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/antiRagging/antiRaggingList'))">
        <a routerLinkActive="active">Anti-Ragging List</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/antiRagging/antiRaggingView'))">
        <a routerLinkActive="active">Anti-Ragging View </a>
    </li>
</ul>
<!-- Anti-Ragging Module  === ARPMSecInCharge-->

    <ul class="breadcrumb" *ngIf="router.url.includes('/main/internal/antiRagging') && (roleName==='ARPMSecInCharge' || roleName==='ARPMAsstSecty' || roleName==='ARPMAssistantSectionOfficer' || roleName ==='ARPMSecExecutive' || roleName === 'System Admin' || roleName==='ServerSecExecutive')">
        <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
        <li *ngIf="(router.url.includes('/main/internal/antiRagging/sectionantiRaggingDashboard'))">
            <a routerLinkActive="active">Anti-Ragging Dashboard </a>
           
        </li>
         <li *ngIf="(router.url.includes('/main/internal/antiRagging/sectionantiRaggingList'))">
        <a routerLinkActive="active">Anti-Ragging List </a>
        </li>
        <li *ngIf="(router.url.includes('/main/internal/antiRagging/antiRaggingView'))">
            <a routerLinkActive="active">Anti-Ragging View </a>
        </li>
        <li *ngIf="(router.url.includes('/main/internal/antiRagging/antiRaggingEditPermission'))">
            <a routerLinkActive="active">Anti-Ragging Edit Permission </a>
        </li>
   </ul>
<!-- Anti-Ragging Module End -->

<!-- legel (dhiraji login) -->
<ul class="breadcrumb" *ngIf="(router.url.includes('legal/')) && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
|| roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' 
|| roleName==='ServerSecExecutive' || roleName==='System Admin')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <!-- legal start-->
    <!-- <li *ngIf="(router.url.includes('legal/legalDashboard'))">
        <a routerLink="legal/legalDashboard" routerLinkActive="active">Case List Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('legal/newcase'))">
        <a routerLink="legal/legalDashboard" routerLinkActive="active">Create New Case</a>
    </li> -->
     <!-- legal end-->
     <!-- mapping start-->
    <li *ngIf="(router.url.includes('legal/advocatecourtmapping'))">
        <a>Advocate Court Mapping</a>
    </li>
    <li *ngIf="(router.url.includes('legal/advocateCourtMappingAdd'))">
        <a>Advocate Court Mapping</a>
    </li>
    <li *ngIf="(router.url.includes('legal/caseToDoListMapping'))">
        <a>Case To Do List Mapping</a>
    </li>
    <li *ngIf="(router.url.includes('legal/taggingConnectedCasesInACourt'))">
        <a>Tagging Connected Cases In A Court Mapping</a>
    </li>
    <!-- mapping end-->
    <li *ngIf="(router.url.includes('legal/assignChangeAdvocate'))">
        <a>Assign Advocate </a>
    </li>
    
    <li *ngIf="(router.url.includes('legal/changeAdvocate'))">
        <a>Change Advocate </a>
    </li>

    <li *ngIf="(router.url.includes('legal/counterReplyAffidavit'))">
        <a>Counter Reply Affidavit </a>
    </li>
  
    <li *ngIf="(router.url.includes('legal/dciAdvocateCommunication'))">
        <a>DCI V/S Advocate Communication </a>
    </li>
    
    <li *ngIf="(router.url.includes('legal/advocateInvoiceSubmission'))">
        <a>Advocate Invoice Submission </a>
    </li>
   
    <li *ngIf="(router.url.includes('legal/queriesReports'))">
        <a>Queries/Reports </a>
    </li>
   
    <li *ngIf="(router.url.includes('legal/documentRepository'))">
        <a>Document Repository </a>
    </li>
    
      <!-- master start-->
    <li *ngIf="(router.url.includes('legal/courtMaster'))">
        <a>Court Master </a>
    </li>
   
    <li *ngIf="(router.url.includes('legal/courtBenchMaster'))">
        <a>Court Bench Master </a>
    </li>

    <li *ngIf="(router.url.includes('legal/courtBenchAdd'))">
        <a>Court Bench Master </a>
    </li>

    <li *ngIf="(router.url.includes('legal/courtTypeMaster'))">
        <a>Court Type Master </a>
    </li>

    <li *ngIf="(router.url.includes('legal/courtTypeAdd'))">
        <a>Court Type Master </a>
    </li>

    <li *ngIf="(router.url.includes('legal/advocateCategory'))">
       <a>Advocate Category Master</a>
   </li>
  
   <li *ngIf="(router.url.includes('legal/advocateMaster'))">
       <a>Advocate Master </a>
   </li>
  
   <li *ngIf="(router.url.includes('legal/caseCategoryMaster'))">
       <a>Case Category Master </a>
   </li>
  
   <li *ngIf="(router.url.includes('legal/caseTypeMaster'))">
       <a>Case Type Master</a>
   </li>
  
   <li *ngIf="(router.url.includes('legal/fileMaster'))">
       <a>File Master</a>
   </li>
  
   <li *ngIf="(router.url.includes('legal/advocateFeeMaster'))">
       <a>Advocate Fee Master </a>
   </li>
  
   <li *ngIf="(router.url.includes('legal/documnetTemplateMaster'))">
       <a>Document Template Master </a>
   </li>
   <li *ngIf="(router.url.includes('legal/documentTemplateView'))">
    <a>Document Template Master </a>
</li>
  
   <li *ngIf="(router.url.includes('legal/caseToDoListMaster'))">
       <a>Case To do List Master </a>
   </li>
   <li *ngIf="(router.url.includes('legal/caseFileManagement'))">
    <a>Case File Management </a>
</li>
   
</ul>
  <!-- master end -->
    <!-- legal end-->
    
<!-- Self Assessment Report-->
<ul class="breadcrumb" *ngIf="(router.url.includes('college/collegeProfile')) && (roleName==='College Principal' || roleName === 'College Representative')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/collegeProfile/collegeDashboard'))">
        <a> College Dashboard </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/generalInformation'))">
        <a> General Information </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/bankDetails'))">
        <a> Bank Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/infrastructure'))">
        <a> Infrastructure </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/editInfrastructure'))">
        <a> Edit Infrastructure Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/centralLibrary'))">
        <a> Central Library + Department Library </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/constructionPlanning'))">
        <a> Construction And Planning </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/equipment'))">
        <a> Equipment </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/editEquipment'))">
        <a> Edit Equipment </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/attachedHospital'))">
        <a> Attached Hospital Details + Clinical </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/collegeStaffList'))">
        <a> Dental Teaching Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/addCollegeStaff'))">
        <a> Add Dental College Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/viewCollegeStaff'))">
        <a> View College Staff Details </a>
    </li>    
    <li *ngIf="(router.url.includes('college/collegeProfile/viewNonCollegeStaff'))">
        <a> View Non College Staff Details </a>
    </li>    
    <li *ngIf="(router.url.includes('college/collegeProfile/medicalTeachingStaffList'))">
        <a> Medical Teaching Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/addmedicalTeachingStaff'))">
        <a> Add Medical College Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/addnonTeachingStaff'))">
        <a routerLinkActive="active">Add Non-Teaching Staff</a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/nonTeachingStaffList'))">
        <a> Non-Teaching Teaching Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/studentAcademic'))">
        <a> Student Academic Presentation </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/academicDetailsList'))">
        <a> Student Academic Presentation </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/editStudentAcademic'))">
        <a> Add/Edit Student Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/teachingLearning'))">
        <a> Teaching/Learning Activities </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/editTeachingLearning'))">
        <a> Add/Edit Student Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/collegeProfile/submitselfassesment'))">
        <a> Submit Self Assessment </a>
    </li>
</ul>

<!-- SAR View -->
<ul class="breadcrumb" *ngIf="(router.url.includes('college/viewSar')) && (roleName==='College Principal' || roleName === 'College Representative' || roleName==='AcademicIncharge' || roleName==='AcademicAsstSecty' || roleName==='AcademicSectionOfficer' || roleName==='AcademicAssistantSectionOfficer' || roleName==='AcademicExecutive' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('college/viewSar')) && (roleName==='AcademicIncharge' || roleName==='AcademicAsstSecty' || roleName==='AcademicSectionOfficer' || roleName==='AcademicAssistantSectionOfficer' || roleName==='AcademicExecutive' || roleName==='ServerSecExecutive' || roleName==='System Admin'|| roleName === 'President UG-PG' || roleName === 'UGPG-DEB' || roleName === 'UGPG Consultant')">
        <a routerLink="college/viewSar/collegeList"> College List </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/generalInformation'))">
        <a> General Information </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/bankDetails'))">
        <a> Bank Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/infrastructure'))">
        <a> Infrastructure </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/editInfrastructure'))">
        <a> Edit Infrastructure Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/centralLibrary'))">
        <a> Central Library + Department Library </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/constructionPlanning'))">
        <a> Construction And Planning </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/equipment'))">
        <a> Equipment </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/editEquipment'))">
        <a> Edit Equipment </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/attachedHospital'))">
        <a> Attached Hospital Details + Clinical </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/collegeStaffList'))">
        <a> Dental Teaching Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/addCollegeStaff'))">
        <a> Add Dental College Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/viewCollegeStaff'))">
        <a> View College Staff Details </a>
    </li>    
    <li *ngIf="(router.url.includes('college/viewSar/viewNonCollegeStaff'))">
        <a> View Non College Staff Details </a>
    </li>    
    <li *ngIf="(router.url.includes('college/viewSar/medicalTeachingStaffList'))">
        <a> Medical Teaching Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/addmedicalTeachingStaff'))">
        <a> Add Medical College Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/addnonTeachingStaff'))">
        <a routerLinkActive="active">Add Non-Teaching Staff</a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/nonTeachingStaffList'))">
        <a> Non-Teaching Teaching Staff </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/studentAcademic'))">
        <a> Student Academic Presentation </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/academicDetailsList'))">
        <a> Student Academic Presentation </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/editStudentAcademic'))">
        <a> Add/Edit Student Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/teachingLearning'))">
        <a> Teaching/Learning Activities </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/editTeachingLearning'))">
        <a> Add/Edit Student Details </a>
    </li>
    <li *ngIf="(router.url.includes('college/viewSar/submitselfassesment'))">
        <a> Submit Self Assessment </a>
    </li>
</ul>


<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/ptr')) && (roleName ==='PTR' || roleName === 'College Principal')">
    <!-- <li><a routerLink="/main/internal/dashboard"style="margin-left: 25px;">Home</a></li> -->
         <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>

        <li *ngIf="(router.url.includes('main/internal/ptr/dashboard/0'))">
        <a routerLinkActive="active">PTR Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/ptr/request'))">
        <a routerLinkActive="active">New PTR Application</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/ptr/editPTR'))">
        <a routerLinkActive="active">Edit PTR Application</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/ptr/viewPTR'))">
        <a routerLinkActive="active">View PTR Application</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/ptr/paymentReceipt'))">
        <a routerLinkActive="active">Payment Receipt</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/ptr/sectionHead/')) && (roleName === 'PDMSSecInCharge')">
    <li><a routerLink="/main/internal/dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('ptr/sectionHead/secHeadPtrDashBoard'))">
        <a routerLinkActive="active">PTR Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('ptr/sectionHead/viewSecHeadPtrDetails'))">
        <a routerLinkActive="active">PTR View</a>
    </li>
    <li *ngIf="(router.url.includes('ptr/sectionHead/secHeadTrackPtrApplicationProcessHistory'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
</ul>


<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/ptr/sectionExcutive/')) && (roleName==='PDMSAsstSecty' 
|| roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive')">
    <li><a routerLink="/main/internal/dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('ptr/sectionExcutive/secExePtrDashBoard'))">
        <a routerLinkActive="active">PTR Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('ptr/sectionExcutive/viewSecExePtrDetails'))">
        <a routerLinkActive="active">PTR View</a>
    </li>
    <li *ngIf="(router.url.includes('ptr/sectionExcutive/secExeTrackPtrApplicationProcessHistory'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/ptr/ptrCommon/')) && (roleName === 'PDMSSecInCharge' || roleName==='PDMSAsstSecty' 
|| roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive')">
<li><a routerLink="/main/internal/dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('ptr/ptrCommon/trackPtrDashBoard'))">
        <a routerLinkActive="active">Track PTR Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('ptr/ptrCommon/viewTrackPtrDetails'))">
        <a routerLinkActive="active">Track PTR View</a>
    </li>
    <li *ngIf="(router.url.includes('ptr/ptrCommon/trackPtrApplicationProcessHistory'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
</ul>


<ul class="breadcrumb" *ngIf="(router.url.includes('main/internal/fqsr')) && (roleName === 'Student' || roleName === 'PDMSSecInCharge' 
|| roleName === 'PDMSAsstSecty' || roleName === 'PDMSSectionOfficer' 
|| roleName === 'PDMSAssistantSectionOfficer' || roleName === 'PDMSExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>    
    <li *ngIf="(router.url.includes('main/internal/fqsr/instructions') || router.url.includes('main/internal/fqsr/request'))">
        <a routerLinkActive="active">Raise a FQSR Request</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/dashboard'))">
        <a routerLinkActive="active">FQSR Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/secDashboard'))">
        <a routerLinkActive="active">FQSR Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/secTrackDashboard'))">
        <a routerLinkActive="active">FQSR Track Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/editRequest'))">
        <a routerLinkActive="active">Edit Request</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/viewRequest'))">
        <a routerLinkActive="active">View Request</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/secViewRequest'))">
        <a routerLinkActive="active">View Request</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/history'))">
        <a routerLinkActive="active">Chronological History</a>
    </li>
    <li *ngIf="(router.url.includes('main/internal/fqsr/referenceView'))">
        <a routerLinkActive="active">Reference View</a>
    </li>
</ul>

<!-- View Agenda -->
<ul class="breadcrumb" *ngIf="(router.url.includes('/main/internal/excu/viewAgenda/'))">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/excu/viewAgenda/'))">
        <a>View Agenda</a>
    </li>
</ul>

<ul class="breadcrumb" *ngIf="(router.url.includes('/main/internal/college/feecollectiondetails')) && (this.roleName === 'AFSecInCharge' || this.roleName === 'College Principal')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/college/feecollectiondetails/feecollection'))">
        <a>Fee Collection</a>
    </li>
    <li *ngIf="(router.url.includes('college/feecollectiondetails/viewFeeList'))">
        <a>List of Payment</a>
    </li>
</ul>

<ul class="breadcrumb"  *ngIf="(router.url.includes('main/internal/sla'))  && (roleName==='System Admin'|| roleName==='ServerSecExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('sla/slaReportsDashboard'))">
        <a>SLA Reports Dashboard</a>
    </li>
    <li *ngIf="(router.url.includes('sla/exportSlaReport'))">
        <a>SLA Report</a>
    </li>
    <li *ngIf="(router.url.includes('sla/summary'))">
        <a>SLA</a>
    </li>
</ul>
 <!-- Anti-Ragging Orientation Program  By Ishvarya ====  College Principle  -->
 <ul class="breadcrumb" *ngIf="router.url.includes('/main/internal/orientationProgram') && 
 (roleName==='College Principal' || roleName === 'ARPMSecInCharge' || roleName === 'ARPMAsstSecty' || roleName === 'ARPMAssistantSectionOfficer' ||  roleName === 'ARPMSecExecutive' || roleName === 'System Admin'|| this.roleName === 'ServerSecExecutive')">
    <li><a routerLink="dashboard"style="margin-left: 25px;">Home</a></li>
    <li *ngIf="(router.url.includes('/main/internal/orientationProgram/secAntiRaggingOrientationProgramList'))">
        <a routerLinkActive="active">Anti-Ragging Orientation Program List</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/orientationProgram/antiRaggingOrientationProgramAdd'))">
        <a routerLinkActive="active">Anti-Ragging Orientation Program Add</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/orientationProgram/antiRaggingOrientationProgramList'))">
        <a routerLinkActive="active">Anti-Ragging Orientation Program List</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/orientationProgram/antiRaggingOrientationProgramView'))">
        <a routerLinkActive="active">Anti-Ragging Orientation Program View</a>
    </li>
    <li *ngIf="(router.url.includes('/main/internal/orientationProgram/antiRaggingOrientationDashboard'))">
        <a routerLinkActive="active">Anti-Ragging Orientation Program Dashboard</a>
    </li>
</ul>